"use client";
import React from 'react';
import '../css/GraduationPage.css';
import '../root.css';
import SEO from '../components/SEO';

function GraduationPage() {
    return (
        <>
            <SEO
                title="Graduation - Announcement Cards & Seating Plan | Samuel Banczík"
                description="A complete graphic identity designed by Samuel Banczík for his high school graduation: announcement cards, name cards and a seating plan."
                keywords="graduation, announcement cards, name cards, seating plans, branding, Samuel Banczík"
                url="https://banczik.com/graduation"
                structuredData={{
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    "name": "Graduation Project",
                    "url": "https://banczik.com/graduation",
                    "description": "Graduation identity, showcasing my skills and knowledge in graphic design.",
                    "breadcrumb": {
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://banczik.com/" },
                            { "@type": "ListItem", "position": 2, "name": "Graduation", "item": "https://banczik.com/graduation" }
                        ]
                    }
                }}
            />
            <div className='graduation-container'>
                <div className='graduation-text'>
                    <div className='graduation-heading'>
                        <h1><span className='special-font' style={{ fontStyle: "italic" }}>ANNOUNCEMENT</span> CARDS</h1>
                        <img src="/images/oznamko.png" alt="Announcement Card" />
                        <img src="/images/oznamko2.png" alt="Announcement Card" />
                        <h1><span className='special-font' style={{ fontStyle: "italic" }}>NAME</span> CARDS</h1>
                        <img src="/images/menovka.svg" alt="Name Card" />
                        <h1>SEATING <span className='special-font' style={{ fontStyle: "italic" }}>PLAN</span></h1>
                        <img src="/images/zasadaciporiadok.png" alt="Seating Plan" />
                        <img src="/images/stoly.png" alt="Seating Plan" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default GraduationPage
